import React from "react";
import PricingDashboard from "../../../components/marketing/reseller/pricing-dashboard";

// Per explicit requirement: global_admin can see Convo Marketing pricing,
// but never edit it — editing is a reseller-only capability (see
// views/reseller-pages/dashboard). Same underlying (currently hardcoded)
// data, just rendered without any of the edit affordances.
const GlobalAdminConvoMarketing: React.FC = () => <PricingDashboard editable={false} />;

export default GlobalAdminConvoMarketing;
